import { rootProjectionNode } from './node/HTMLProjectionNode.mjs';

function useInstantLayoutTransition() {
    return startTransition;
}
function startTransition(cb) {
    if (!rootProjectionNode.current)
        return;
    rootProjectionNode.current.isUpdating = false;
    rootProjectionNode.current.blockUpdate();
    cb === null || cb === void 0 ? void 0 : cb();
}

export { useInstantLayoutTransition };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/projection/use-instant-layout-transition.mjs
// module id = rGJc
// module chunks = 0